export default __webpack_public_path__ + "static/media/Armbands of the Bloodmoon.fe5bfe5f.jpg";